import React, { useEffect } from "react";
import classes from "./user.module.css";
import Sidebar from "../../components/Sidebar";
import Header from "../../components/Header";
import { Navigate, Route, Routes } from "react-router";
import Hymn from "./hymn";
import Subscription from "./subscription";
import ChurchEvents from "./churchevent";
import useRouteLogic from "../../../hooks/useRouteLogic";
import Donations from "./donations";
import Dashboard from "./dashboard";
import Resources from "./resources/Resources";

const User = () => {
   const { redirectTologin } = useRouteLogic();
   useEffect(() => {
      redirectTologin();
   }, [redirectTologin]);

   const [open, setOpen] = React.useState(false);

   const toggleSidebar = () => {
      setOpen((state) => !state);
   };

   return (
      <div className={classes.container}>
         <div className={open ? classes.sidebar : classes.noSidebar}>
            <Sidebar />
         </div>
         <div className={open ? classes.mainContainer : classes.fullPageMain}>
            <Header Open={open} toggleSidebar={toggleSidebar} />

            <div className={classes.mainContent}>
               <Routes>
                  <Route
                     path="dashboard"
                     index
                     element={<Dashboard />}
                     caseSensitive
                  />
                  <Route
                     path="donations"
                     element={<Donations />}
                     caseSensitive
                  />
                  <Route path="hymn" element={<Hymn />} caseSensitive />
                  <Route
                     path="events"
                     element={<ChurchEvents />}
                     caseSensitive
                  />
                  <Route
                     path="subscription"
                     element={<Subscription />}
                     caseSensitive
                  />
                  <Route
                     path="resources"
                     element={<Resources />}
                     caseSensitive
                  />

                  <Route path="/*" element={<Navigate to={"/user/hymn"} />} />
               </Routes>
            </div>
         </div>
      </div>
   );
};

export default User;
